import { render, staticRenderFns } from "./marketplaceAdmin.vue?vue&type=template&id=64e7cb75&"
import script from "./marketplaceAdmin.vue?vue&type=script&lang=js&"
export * from "./marketplaceAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports